// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "message-cP6A_";
var _3 = "message_context-2jz1L";
var _4 = "message__title-21BmR";
var _5 = "message__text-2Q-Kc";
var _6 = "message_info-26GdD";
var _7 = "message__icon-158Og";
var _8 = "message_warning-d-HrU";
export { _1 as "__esModule", _2 as "message", _3 as "message_context", _4 as "message__title", _5 as "message__text", _6 as "message_info", _7 as "message__icon", _8 as "message_warning" }
export default { "__esModule": _1, "message": _2, "message_context": _3, "message__title": _4, "message__text": _5, "message_info": _6, "message__icon": _7, "message_warning": _8 }
